import {
  fetchData,
  fileExceedSizeInMo,
  getImageUrl,
  IframelyMedia,
  mediaFromIframely,
  resizeImage,
  uploadFileToUrl,
} from '@prismamedia/one-components';
import {
  useFocusPointGetter,
  useResolvedImageGetter,
  useUploadUrlGetter,
} from '../apollo/queries/uploadImage.image.graphql';

export const embedImage = (url: string) =>
  fetchData<IframelyMedia>(
    `${config.API_ONE_IFRAMELY}/iframely?uri=${encodeURIComponent(url)}`,
  );

export const useUploadImage = () => {
  const getUploadUrl = useUploadUrlGetter();
  const getResolvedImage = useResolvedImageGetter();
  const getFocusPoint = useFocusPointGetter();

  return async (file: File, namespace: string) => {
    try {
      if (fileExceedSizeInMo(file, 10)) {
        throw new Error('Le fichier fait plus de 10 Mo');
      }
      const resizedImageFile = await resizeImage(file, 3000, 3000);

      const {
        getUploadUrl: { key, uploadURL },
      } = await getUploadUrl({
        namespace,
        originalName: file.name,
      });

      await uploadFileToUrl(resizedImageFile, uploadURL);

      const {
        getResolvedImage: { url },
      } = await getResolvedImage({
        key,
      });

      const iframely = await embedImage(url);

      let oneMedia = mediaFromIframely(iframely);
      const imageUrl = getImageUrl(oneMedia);
      const imageHeight = oneMedia.iframely.meta.height;
      const imageWidth = oneMedia.iframely.meta.width;

      try {
        const res = await getFocusPoint({
          imageUrl,
          imageHeight,
          imageWidth,
        });
        const { x, y, relativeX, relativeY } = res.getFocusPoint;
        oneMedia = { ...oneMedia, focusPoint: { x, y, relativeX, relativeY } };
      } catch (e) {}

      return oneMedia;
    } catch (error) {
      throw new Error(
        `Erreur lors de l'importation du média "${file.name}": ${
          (error as Error)?.message
        }`,
      );
    }
  };
};
